import { createFileRoute } from '@tanstack/react-router';
import {
  dynamicRulesListScreen,
  dynamicRulesSearch,
  loadDynamicRulesMessages,
  loadDynamicRulesScreens,
} from '@/modules/dynamic-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/regras-dinamicas/')({
  validateSearch: dynamicRulesSearch,
  staticData: { screen: dynamicRulesListScreen },
  loader: () => loadDynamicRulesMessages(),
  component: lazyScreen(loadDynamicRulesScreens, 'DynamicRulesListScreen'),
});
